export const environment = {
  production: false,
  envName: 'dev',
  keycloak: {
    // Url of the Identity Provider
    issuer: 'https://raagnale.force-n.sn',

    // Realm
    realm: 'Spring-Boot',

    // The SPA's id.
    // The SPA is registerd with this id at the auth-serverß
    clientId: 'fode-client-dev2',
  },

  apiBaseUrl: 'https://dev-fode.force-n.sn/backfode/fodev2/api',
  openBaseUrl: 'https://dev-fode.force-n.sn/backfode',
  redirectURI: 'https://dev-fode.force-n.sn/fode/#/',
};
